"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "tonengo": {
    "335b5a3d": [{
      "hkey": "972a8b91",
      "slug": "moransengo-tonengo",
      "name": "Moransengo-Tonengo",
      "primary": true,
      "skipSearch": false
    }],
    "tonengo": [{
      "hkey": "972a8b91",
      "slug": "moransengo-tonengo",
      "name": "Moransengo-Tonengo",
      "primary": true,
      "levelFrom": 9,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "d0a76746": [{
      "hkey": "972a8b91",
      "slug": "moransengo-tonengo",
      "name": "Moransengo-Tonengo",
      "primary": true,
      "skipSearch": false
    }],
    "cerrabello": [{
      "hkey": "972a8b91",
      "slug": "moransengo-tonengo",
      "name": "Moransengo-Tonengo",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "1727a2b9": [{
      "hkey": "972a8b91",
      "slug": "moransengo-tonengo",
      "name": "Moransengo-Tonengo",
      "primary": true,
      "skipSearch": false
    }],
    "fegine": [{
      "hkey": "972a8b91",
      "slug": "moransengo-tonengo",
      "name": "Moransengo-Tonengo",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "df027755": [{
      "hkey": "972a8b91",
      "slug": "moransengo-tonengo",
      "name": "Moransengo-Tonengo",
      "primary": true,
      "skipSearch": false
    }],
    "ottini": [{
      "hkey": "972a8b91",
      "slug": "moransengo-tonengo",
      "name": "Moransengo-Tonengo",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "0f6ae3c2": [{
      "hkey": "972a8b91",
      "slug": "moransengo-tonengo",
      "name": "Moransengo-Tonengo",
      "primary": true,
      "skipSearch": false
    }],
    "pareglio": [{
      "hkey": "972a8b91",
      "slug": "moransengo-tonengo",
      "name": "Moransengo-Tonengo",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;